import { render, staticRenderFns } from "./LicenseSelectorItem.vue?vue&type=template&id=19b7331a&scoped=true&"
import script from "./LicenseSelectorItem.vue?vue&type=script&lang=js&"
export * from "./LicenseSelectorItem.vue?vue&type=script&lang=js&"
import style0 from "./LicenseSelectorItem.vue?vue&type=style&index=0&id=19b7331a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b7331a",
  null
  
)

export default component.exports